import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import prong from './assets/prong-light-bgimage.svg';
import winStoreLogo from './assets/winStoreLogo.svg';
import { getProngStyles } from './styles/win-prong-light-style';


export const ProngLight = ({
  styleOverrides,
}) => {
  const classes = useDefaultStyles(getProngStyles({ styleOverrides }));

  return (
    <div className={classnames('prong-background', classes.prongBackground)}>
      <img className={classnames('prong-background-image', classes.background)} alt="" src={prong} />
      <img className={classnames('prong-win-store-logo-image', classes.winStoreLogo)} alt="" src={winStoreLogo} />
      <div className={classnames('prong-win-store', classes.winStore)} alt="">
        {_TL_('Microsoft store')}
      </div>
      <div className={classnames('prong-sponsored', classes.sponsored)} alt="">
        {_TL_('Sponsored')}
      </div>
    </div>
  );
};

ProngLight.propTypes = {
  styleOverrides: PropTypes.shape({}),
};

ProngLight.defaultProps = {
  styleOverrides: {},
};

